import "./spinner.css";

export default function Spinner({ size = '2.5rem', color = '#fff'}) {
    return (
        <div className='flex flex-1 self-center justify-center' style={{width: size, height: size}}>
            <div className='loader' data-testid="spinner" style={{ '--spinner-color': color }as React.CSSProperties} />
        </div>
    );
}